import React, { useMemo } from 'react';
import './HeroSection.scss';
import { Button } from 'semantic-ui-react';
import { Link, NavLink }                                         from "react-router-dom"
import htmr                                                                           from "htmr";
import languageStore               from "stores/languageStore"

const TOTAL_IMAGES = 29;
const IMAGES_PER_COLUMN = 5;
const COLUMNS = 5;

const getShuffledUniqueNumbers = (count, max) => {
  const numbers = Array.from({ length: max }, (_, i) => i);
  for (let i = numbers.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
  }
  return numbers.slice(0, count);
};

const HeroSection = () => {
  // Einmalige zufällige Bildverteilung für alle Spalten
  const imageSets = useMemo(() => {
    const totalNeeded = COLUMNS * IMAGES_PER_COLUMN;

    if (totalNeeded > TOTAL_IMAGES) {
      console.warn('Nicht genug eindeutige Bilder für alle Spalten.');
      return Array.from({ length: COLUMNS }, () => []);
    }

    const shuffled = getShuffledUniqueNumbers(totalNeeded, TOTAL_IMAGES);
    return Array.from({ length: COLUMNS }, (_, colIndex) => {
      return shuffled.slice(
        colIndex * IMAGES_PER_COLUMN,
        (colIndex + 1) * IMAGES_PER_COLUMN
      );
    });
  }, []);
  const { currentLanguage } = languageStore;
  return (
    <div className="hero">
      <div className="hero--ticker">
        {imageSets.map((imageNums, colIndex) => {
          const isUp = colIndex % 2 !== 0;
          const animationDuration = `${(35 * 50) + Math.random() * 50}s`;
          return (
            <div
              key={colIndex}
              className={`ticker column ${isUp ? 'column-up' : ''}`}
              data-direction={isUp ? 'up' : 'down'}
            >
              <div
                className="ticker__inner"
                style={{ animationDuration }}
              >
                {Array.from({ length: 100 }).flatMap(() => imageNums).map((num, i) => (
                  <img
                    key={i}
                    className="item"
                    src={`/image/Produkte-${num}.jpg`}
                    alt={`Produkt ${num}`}
                    loading="lazy"
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>

      <div className="hero--content">
        <div className="hero--content-text">
          <p className="f2 fw6">
            {htmr(translate("Startseitenmeldung"))}
          </p>
        {/*          <p className="">
            <Link to={currentLanguage === "de" ? "/collection/medizin" : "/collection/medicine"}>
            <Button 
                    style={{
                        borderRadius: "35px", 
                        height: "60px", 
                        width: "200px", 
                        marginBottom: "10px",
                        backgroundColor: "white", 
                        color: "#369678",
                        transition: "all 0.3s ease",
                        
                    }} 
                    className=" ml3 pl3 mr2"
                    onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#369678";
                }}
                >
                {translate("Medizinprodukte")}
                </Button>
                </Link>
                <Link to={currentLanguage === "de" ? "/collection/labor" : "/collection/laboratory"}>
            <Button 
                    style={{
                        borderRadius: "35px", 
                        height: "60px", 
                        width: "200px", 
                        marginBottom: "10px",
                        backgroundColor: "white", 
                        color: "#369678",
                        transition: "all 0.3s ease",
                    }} 
                    className=" ml3 pl3 mr2"
                    onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#369678";
                }}
                >
                {translate("Laborprodukte")}
                </Button>
                </Link>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Slider/HeroSection.js